import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { breadcrumb, enrollModal, showModal } from "../../redux/actions";
import DeletePlanActivities from "../learnerplan/DeletePlanActivities";
import MainLayOut from "../MainLayOut/MainLayOut";
import Challenges from "./Challenges";
import Developmental from "./Developmental";
import LifeEvent from "./LifeEvent";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Line } from "rc-progress";
import TabingPopup from "./TabingPopup";
import { getCalculatePlanDate, getCurrentDaysOfWeek } from "../../utils/helper";
import { courseEnrollmentWithSession, getAllUsersDetail, getLifePlan } from "../../redux/actions/APIs";
import { PATHS } from "../../utils";
import ChildEnrollmentPopUp from "../base/ChildEnrollmentPopUp";
const CourseCatlog = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [loader, setLoader] = useState(false);

    const {
        loggedInUser,
        defaultChildData,
        alluserdetails,
        getParentToolResponses,
        courseEnrollResponse,
        response,
        modalData,
    } = useSelector((state) => state.collections);

    const [getTab, setTab] = useState("Developmental");
    const [getPopupData, setPopupData] = useState();
    const [tabCount, setTabCount] = useState(1);
    const [deletePlan, setDeletePlan] = useState();


    //  console.log("location : ", location, getTab);

    useEffect(()=>{
        if(location?.state?.type){
            setTab(location?.state?.type);
        }
    },[location?.state?.type])

    useEffect(() => {
        if (location?.state?.isCouponPopUp) {
            // if (!alluserdetails?.records[0]?.isCoupanSelected && alluserdetails?.records[0]?.role?.name === "PARENT") {
            //     // dispatch(showModal({ type: "DisCountOfferPopup" }));
            //     history.replace({ ...history.location, state: {} });
            // }
            if (loggedInUser?.role?.name === "PARENT") {
                dispatch(showModal({ type: "DimensionHintPopup" }));
                history.replace({ ...history.location, state: {} });
            }
        }
    }, [location, loggedInUser])

    // useEffect(() => {
    //     dispatch(showModal({ type: "DimensionHintPopup" }));
    // }, [])

    useEffect(() => {
        dispatch(breadcrumb({ title: "📚 Course Catalog" }));
    }, [defaultChildData]);

    const handleTab = (type) => {
        setTab(type);
    }

    const handleClose = () => {
        setPopupData();
    }

    /*
    const handleEnroll = (courseObj) => {
        //  console.log("handleEnroll : ", courseObj);
        let getCourseArr = [courseObj]
        if (loggedInUser?.children?.length > 1) {
            dispatch(showModal({ type: "ChildEnrollmentPopUp", course: getCourseArr, }))
        } else {
            getCourseArr[0].childId = defaultChildData?.id;
            dispatch(enrollModal(getCourseArr));
        }
    }
    */

    const handleEnroll = (courseObj) => {
        let getCourseArr = [courseObj]
        //  console.log("handleEnroll courseCatog  : ", getCourseArr);
        getCourseArr[0].childId = defaultChildData?.id;
        if (loggedInUser?.children?.length > 1) {
            dispatch(showModal({ type: "showLearnerEnrollPopUp", course: getCourseArr }));
        } else {
           handleEnrollCourse(getCourseArr);
        }
    }

    useEffect(() => {
        if (getParentToolResponses?.isTabbingPopUp) {
            if (tabCount === 1) {
                handleTab("Developmental")
            } else if (tabCount === 2) {
                handleTab("LifeEvent")
            } else {
                handleTab("Challenges")
            }  
        }  
    },[getParentToolResponses, tabCount])

    const handleEnrollCourse = (getCourseArr) => {
        
            if (getCourseArr?.length > 0) {
                let curenDate = new Date();
                let getCurentDays = getCurrentDaysOfWeek(curenDate, 2);	
                let enrollCourseData = handleCalculateStartDateEndDate(getCourseArr, 2, 30, getCurentDays, getCourseArr[0]?.name);
                console.log("handleEnrollCourse @ : ", enrollCourseData, getCourseArr);
                    if (enrollCourseData?.courses?.length === 1) {
                        setLoader(getCourseArr[0]?.id);
                        dispatch(courseEnrollmentWithSession(getCourseArr[0]?.childId, getCourseArr[0]?.skill?.id, getCourseArr[0]?.id, enrollCourseData));
                    }
        }
    }

   

    const handleCalculateStartDateEndDate = (courses, sitting, duration, planDays, planName) => {
            let getPlanDateArr = getCalculatePlanDate(
                courses,
                duration,
                sitting,
                "",
                planDays
            );
            if (getPlanDateArr.length > 0) {
                let array = {
                    name: planName,
                    sittings: sitting,
                    duration: duration,
                    planCount: 1,
                    timeZone: loggedInUser?.timeZone
                        ? loggedInUser?.timeZone
                        : "US/Eastern",
                    planType: courses[0]?.planType,
                    planId: courses[0]?.planId,
                    userId: courses[0]?.childId,
                    iscourseupdate: true,
                    daysOfWeek: planDays,
                    courses: getPlanDateArr,
                };
                return array;
            }
        };

    // useEffect(()=>{
    //     if(response?.success && response?.message !== "You're Child is already enrolled in this Course"){
    //         history.push({
    //                            pathname: PATHS.MYPLAN_PAGE,
    //                        })
    //          dispatch(courseEnrollmentWithSession());
    //     }
    // },[response])

     useEffect(()=>{
        if(courseEnrollResponse?.success){
            if (!defaultChildData?.isUserPlan) {
                            dispatch(getAllUsersDetail());
            }
            if(courseEnrollResponse?.message === "You're Child is already enrolled in this Course"){
                setDeletePlan({
                    title: 'Already Enrolled',
                    message: courseEnrollResponse?.message,
                });
            }else{
                
                closeModal();
                 history.push({
                               pathname: PATHS.MYPLAN_PAGE,
                               state: {enrollResponseObj : courseEnrollResponse}
                           })       
            }
            setLoader(false);
            dispatch(courseEnrollmentWithSession());
            
        }
    },[courseEnrollResponse])

    const closeModal = () => {
            dispatch(showModal());
        }

    const closePlan = () => {
        setDeletePlan();
    }
    
    // console.log("courseEnrollResponse @ : ", defaultChildData,loggedInUser, alluserdetails );

    return (
        <MainLayOut>
            <div className="LeftpanelContent min-width-100">
                <div className="coursecatalogcontainer coursecatasoclist">

                    <div className="mytabList  pb-4 pt-4 pointer">
                        <ul>
                            <li className={`w-33 text-center ${getTab === "Developmental" && "Active_tab"} `}
                                onClick={() => handleTab("Developmental")}
                            >Choose By Developmental Area

                                 {getParentToolResponses?.isTabbingPopUp && tabCount === 1 && (
                                    <TabingPopup tabCount={tabCount} setTabCount={setTabCount}   />
                                 )}
                            </li>
                            <li className={`w-33 text-center ${getTab === "LifeEvent" && "Active_tab"} `}
                                onClick={() => handleTab("LifeEvent")}
                            >Navigate a Life Event

                                  {getParentToolResponses?.isTabbingPopUp && tabCount === 2 && (
                                    <TabingPopup tabCount={tabCount} setTabCount={setTabCount}/>
                                 )}
                            </li>
                            <li className={`w-33 text-center ${getTab === "Challenges" && "Active_tab"} `}
                                onClick={() => handleTab("Challenges")}
                            >Match by Concerns or Challenges

                                  {getParentToolResponses?.isTabbingPopUp && tabCount === 3 && (
                                    <TabingPopup tabCount={tabCount} setTabCount={setTabCount} />
                                 )}
                            </li>
                        </ul>
                    </div>

                    {getTab === "Developmental" && (
                        <Developmental handleEnroll={handleEnroll}
                                       loader={loader}               
                        />
                    )}
                    {getTab === "LifeEvent" && (
                        <LifeEvent />
                    )}
                    {getTab === "Challenges" && (
                        <Challenges setPopupData={setPopupData} />
                    )}
                </div>
            </div>
            {getPopupData && (
                <DeletePlanActivities
                    closePlan={handleClose}
                    deletePlan={getPopupData}
                />
            )}
            {modalData?.type === "showLearnerEnrollPopUp" && (
                <ChildEnrollmentPopUp closeModal={closeModal} handleEnrollCourse={handleEnrollCourse} loader={loader} />
            )}
            {deletePlan && (
                <DeletePlanActivities
                    closePlan={closePlan}
                    deletePlan={deletePlan}
                />
            )}
        </MainLayOut>
    )
}
export default CourseCatlog;